/**
 * Masks a token value for display, keeping only the last 4 characters visible.
 * Token UIDs identify a driver, so lists never show them in full; the token
 * detail slide-in is the one place where they can be revealed.
 */
export const maskTokenValue = (value?: string | null): string => {
  if (!value) {
    return '';
  }

  if (value.length <= 4) {
    return '••••';
  }

  return `•••• ${value.slice(-4)}`;
};
